import type { Options } from 'motion-v';

type MotionTransition = Options['transition'];

const EASE_POWER2_OUT = [0.25, 0.46, 0.45, 0.94] as const;

export const cardStagger: MotionTransition = {
    staggerChildren: 0.1,
    delayChildren: 0.15,
};

export const sectionTransition = (index: number): MotionTransition => ({
    duration: 0.4,
    ease: EASE_POWER2_OUT,
    delay: 0.1 + index * 0.12,
});
